module.exports = __webpack_public_path__ + "img/antes_despues_222.a2dfe477.png";